import React from 'react'
import Translations from "../../../services/translation";
import "./style.scss";

const ZaamAgeConfirmationNote = () => {
    const strings = Translations["keys"][Translations.activeLang];
  return (
    <div className="zaam-age-confirmation vmo-message-warning">
        <p>{strings["ZAAM_AGE_CONFIRMATION"]}</p>
    </div>  
  )
}

export default ZaamAgeConfirmationNote